import { Component, ContentChild, Directive, Optional, TemplateRef } from '@angular/core';
import { GridDataBase } from '@ui/grid-view/grid-data.abstract';

export class ListItemContext
{
  constructor(
    public $implicit: any,
    public cell: any
  ) { }
}

@Directive({
  selector: '[list-item]'
})
export class ListItemDirective {
  constructor(@Optional() public readonly templateRef: TemplateRef<ListItemContext>) {
  }
}

@Component({
  selector: 'ui-custom-template-view',
  templateUrl: './custom-template-view.component.html',
  styleUrls: ['./custom-template-view.component.scss']
})
export class CustomTemplateViewComponent<T> extends GridDataBase<T> {
  @ContentChild(ListItemDirective)
  templateOutlet: ListItemDirective;

  pageSizeOptions = [6, 12, 24];
}
